import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import styles from './Icon.module.css.js';
import { iconMap } from './iconMap.js';

function Icon({ name, size = "base", matchTextColour = false, }) {
    const IconElement = iconMap[name];
    return (jsx(IconElement, { className: clsx(styles[size], {
            [styles.matchTextColour]: matchTextColour,
        }), "data-testid": `${name} icon` }));
}

export { Icon };
//# sourceMappingURL=Icon.js.map
